/* eslint-disable no-shadow */
import { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import {
  fetchAppointmentNote,
  updateAppointmentNote,
} from '../../../actions/sessions';
import PreviousNotes from './PreviousNotes';
import QuillEditor from '../../global/QuillEditor';

const styles = {
  header: {
    fontSize: '20px',
  },
  hr: {
    borderTop: '2px solid #c2adff',
    width: '25px',
    marginLeft: 0,
    marginTop: '10px',
  },
  subtext: {
    fontSize: '14px',
    color: 'rgba(146, 180, 255, 0.65)',
    fontStyle: 'italic',
    paddingLeft: '12px',
  },
};

function NotesBox({
  appointmentNoteID,
  fetchAppointmentNote: fetchAppointmentNoteAction,
  updateAppointmentNote: updateAppointmentNoteAction,
  allAppointmentNotes,
}) {
  const [text, setText] = useState('');
  const propsRef = useRef({
    updateAppointmentNoteAction,
    appointmentNoteID,
  });
  propsRef.current = {
    updateAppointmentNoteAction,
    appointmentNoteID,
  };

  const updateNote = useRef(
    _.debounce(value => {
      const {
        updateAppointmentNoteAction: updateNoteAction,
        appointmentNoteID: noteId,
      } = propsRef.current;
      updateNoteAction(noteId, { note: value });
    }, 500),
  ).current;

  useEffect(() => {
    if (appointmentNoteID) {
      fetchAppointmentNoteAction(appointmentNoteID, response =>
        setText(response.data.note),
      );
    }
    // Match class componentDidMount: run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <h1 style={styles.header}>
        <FormattedMessage defaultMessage="Notes" />
      </h1>
      <hr style={styles.hr} />
      <p style={styles.subtext}>
        <FormattedMessage defaultMessage="Your Notes will be automatically saved." />
      </p>

      <PreviousNotes allAppointmentNotes={allAppointmentNotes} />
      <QuillEditor value={text} onChange={value => updateNote(value)} />
    </div>
  );
}

NotesBox.propTypes = {
  appointmentNoteID: PropTypes.number.isRequired,
  fetchAppointmentNote: PropTypes.func.isRequired,
  updateAppointmentNote: PropTypes.func.isRequired,
  allAppointmentNotes: PropTypes.array.isRequired,
};

export default connect(null, { fetchAppointmentNote, updateAppointmentNote })(
  NotesBox,
);
